export function returnCubicWeight(shipping, returnOnlyCubicWeight = false) {

  const { length, height, width, weight } = shipping;
  const cubWeight = (length * height * width) / 6000;

  const newWeight =
    cubWeight > 5
      ? weight > cubWeight
        ? weight
        : cubWeight
      : weight;

  return returnOnlyCubicWeight ? cubWeight?.toFixed(2) : newWeight?.toFixed(2)
}